/**
 * One line per thing the coins were flipped for, in the order they were flipped: "Thunder Jolt: tails",
 * "Twineedle: heads, tails".
 *
 * @param {Array<{label: string, heads: boolean}>} flips
 * @returns {string[]}
 */
export function coinFlipLines(flips) {
  const byLabel = new Map();

  flips.forEach(({ label, heads }) => {
    byLabel.set(label, [...(byLabel.get(label) || []), heads ? 'heads' : 'tails']);
  });

  return [...byLabel].map(([label, results]) => `${label}: ${results.join(', ')}`);
}
